import { BMEventsType } from '../types';
import type { BasePageSegmentLoadMetricData } from './page-segment-load';

export const isPageSegmentLoadMetricData = (data: any): data is BasePageSegmentLoadMetricData => {
	return data.type === BMEventsType.PAGE_SEGMENT_LOAD;
};
